window.$ = jQuery
export default jQuery;